module.exports = __webpack_public_path__ + "media/images/scribe-arrow-86d3858c.svg";